/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailTemplate
 */
export interface EmailTemplate {
    /**
     * 
     * @type {string}
     * @memberof EmailTemplate
     */
    html_content: string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplate
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplate
     */
    plain_content: string;
}

/**
 * Check if a given object implements the EmailTemplate interface.
 */
export function instanceOfEmailTemplate(value: object): value is EmailTemplate {
    if (!('html_content' in value) || value['html_content'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('plain_content' in value) || value['plain_content'] === undefined) return false;
    return true;
}

export function EmailTemplateFromJSON(json: any): EmailTemplate {
    return EmailTemplateFromJSONTyped(json, false);
}

export function EmailTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'html_content': json['html_content'],
        'subject': json['subject'],
        'plain_content': json['plain_content'],
    };
}

export function EmailTemplateToJSON(json: any): EmailTemplate {
    return EmailTemplateToJSONTyped(json, false);
}

export function EmailTemplateToJSONTyped(value?: EmailTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'html_content': value['html_content'],
        'subject': value['subject'],
        'plain_content': value['plain_content'],
    };
}

